import { useMetadata } from 'hooks/useMetadata'; // Import the hook
import Subscribe from './subscribe';

export default function PageSubscribe() {
  useMetadata({
    page: 'subscribe'
  });

  return (
    <>
      <Subscribe />
    </>
  )
}